import React from 'react'

// components
import Modal from './Modal'

export default function DeleteBadgeModal(props) {
	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose}>
			<div className='DeleteBadgeModal'>
				<h1>Are You Sure?</h1>
				<p>You are about to delete this badge.</p>

				<div>
					<button onClick={props.onDeleteBadge} className='btn btn-danger mr-3'>
						Delete
					</button>
					<button onClick={props.onClose} className='btn btn-primary'>
						Cancel
					</button>
				</div>
			</div>
		</Modal>
	)
}
